import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=16d39277&scoped=true&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=16d39277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d39277",
  null
  
)

export default component.exports